import React, { useContext, useEffect } from "react";
import { StoresContext } from "../_app";
import { useSearchParams } from "next/navigation";
import { setAfterLoginAction, clearAfterLoginAction } from "../login-success";

const LoginPage = () => {
  const searchParams = useSearchParams();
  const rootStore = useContext(StoresContext);

  useEffect(() => {
    const nextParam = searchParams.get("_next");
    if (nextParam !== null) {
      setAfterLoginAction("GoToUrl", "/", nextParam);
    } else {
      clearAfterLoginAction();
    }
    window.location.href = rootStore.userStore.getAuthUrl();
  }, []);

  return <div />;
};

export default LoginPage;
